import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'
import {
  CalculatePriceRequest,
  CalculatePriceResponse,
} from 'src/shared/types/pricing-types'

export const calculatePrice = (
  data: CalculatePriceRequest[],
  abortSignal?: AbortSignal,
) =>
  monolithHttpClient.post<CalculatePriceResponse[]>(
    `${window.location.origin}/api/payment/calculate-price/v2`,
    data,
    {
      signal: abortSignal,
    },
  )
